import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('WindowToken', {
  providedIn: 'root',
  factory: () => window
});

export const INPUT_DEBOUNCE_TIME = new InjectionToken<number>('InputDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const GOOGLE_MAPS_INPUT_DEBOUNCE_TIME = new InjectionToken<number>('GoogleMapsInputDebounceTime', {
  providedIn: 'root',
  factory: () => 1000
});

export const WAIT_FOR_QUERY_PARAMS_TO_BE_SET_DEBOUNCE_TIME = new InjectionToken<number>(
  'WaitingForQueryParamsToBeSetDebounceTime',
  {
    providedIn: 'root',
    factory: () => 1000
  }
);

export const BOOKING_DEBOUNCE_TIME = new InjectionToken<number>('BookingDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const HOLDER_DEBOUNCE_TIME = new InjectionToken<number>('HolderDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const TICKET_ASSIGNMENT_DEBOUNCE_TIME = new InjectionToken<number>('TicketAssignmentDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const ADDITIONAL_SERVICES_DEBOUNCE_TIME = new InjectionToken<number>('AdditionalServicesDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const CUSTOMIZATION_DEBOUNCE_TIME = new InjectionToken<number>('CustomizationDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const HELPER_DEBOUNCE_TIME = new InjectionToken<number>('HelperDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const EXHIBITION_DEBOUNCE_TIME = new InjectionToken<number>('ExhibitionDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const LEGITIMATION_DEBOUNCE_TIME = new InjectionToken<number>('LegitimationDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const TRANSLATION_DEBOUNCE_TIME = new InjectionToken<number>('TranslationDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const STEP_FORMS_DEBOUNCE_TIME = new InjectionToken<number>('StepFormsDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const USER_DEBOUNCE_TIME = new InjectionToken<number>('UserDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const COLORIZER_DEBOUNCE_TIME = new InjectionToken<number>('ColorizerDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const PRESS_NEWS_DEBOUNCE_TIME = new InjectionToken<number>('PressNewsDebounceTime', {
  providedIn: 'root',
  factory: () => 50
});

export const PARKING_LICENSE_PLATE_DEBOUNCE_TIME = new InjectionToken<number>('ParkingLicensePlateDebounceTime', {
  providedIn: 'root',
  factory: () => 500
});
